import {Component} from '@angular/core';

@Component({
  selector: 'app-income-icon',
  templateUrl: './income-icon.component.html',
  standalone: false,
})
export class IncomeIconComponent {}
